export default "__VITE_ASSET__fba0a0b6__"